import { TReduxActions, IPublications } from '../../types/redux';
import { actionTypes } from '../../constants/actionTypes';

const initialState: IPublications = {
  data: null,
  isError: false,
  isFetching: undefined,
  articles: {},
};

export const publicationsReducer = (state: IPublications = initialState, action: TReduxActions): IPublications => {
  switch (action.type) {
    case actionTypes.GET_PUBLICATION_REQUEST:
    case actionTypes.GET_PUBLICATIONS_LIST_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case actionTypes.GET_PUBLICATIONS_LIST_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        isError: false,
        data: action.payload.data,
      };
    }

    case actionTypes.GET_PUBLICATION_FAILURE:
    case actionTypes.GET_PUBLICATIONS_LIST_FAILURE: {
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    }

    case actionTypes.GET_PUBLICATION_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        isError: false,
        articles: {
          ...state.articles,
          [action.payload.articleId]: action.payload.data,
        },
      };
    }

    default: {
      return state;
    }
  }
};
